var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSecuritysystemAlarm(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.2499 15.4997L11.9068 15.2634L10.2499 14.7634C10.1768 14.7422 10.1058 14.7141 10.038 14.6797C9.37311 14.319 8.8086 13.7983 8.3955 13.1647L6.89238 10.7734C6.67675 10.4484 6.53113 10.1615 6.86925 9.93778C7.20675 9.71403 8.09488 10.1703 8.3105 10.4953L9.28738 11.9697L6.02113 6.91403C5.91818 6.75187 5.8838 6.55549 5.92551 6.368C5.96723 6.18051 6.08164 6.01724 6.24363 5.91403V5.91403C6.40213 5.80611 6.59688 5.76525 6.7854 5.80038C6.97391 5.8355 7.14088 5.94376 7.24988 6.10153L9.46363 9.44278L9.12988 8.93715C9.0271 8.77495 8.99281 8.57862 9.03451 8.39118C9.07622 8.20374 9.19052 8.04047 9.35238 7.93715V7.93715C9.51042 7.82886 9.70486 7.78741 9.89334 7.82182C10.0818 7.85624 10.2491 7.96374 10.3586 8.1209L10.8555 8.8709L10.6718 8.59403C10.569 8.43175 10.5348 8.23536 10.5767 8.04792C10.6185 7.86047 10.7329 7.69725 10.8949 7.59403V7.59403C11.0529 7.48573 11.2474 7.44428 11.4358 7.4787C11.6243 7.51311 11.7916 7.62061 11.9011 7.77778L12.4099 8.54653L12.2143 8.2509C12.1115 8.0887 12.0772 7.89237 12.1189 7.70493C12.1606 7.51749 12.2749 7.35422 12.4368 7.2509V7.2509C12.5947 7.14244 12.7892 7.10089 12.9778 7.13532C13.1663 7.16975 13.3335 7.27735 13.443 7.43465L14.5399 9.08965C15.1024 9.93465 15.433 10.8565 15.6268 11.8528C15.6464 11.958 15.6521 12.0654 15.6436 12.1722L15.593 12.8147L15.7499 13.4997",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.25 12.25H0.75C0.617392 12.25 0.490215 12.1973 0.396447 12.1036C0.302678 12.0098 0.25 11.8826 0.25 11.75V1C0.25 0.867392 0.302678 0.740215 0.396447 0.646447C0.490215 0.552678 0.617392 0.5 0.75 0.5H8.75C8.88261 0.5 9.00979 0.552678 9.10355 0.646447C9.19732 0.740215 9.25 0.867392 9.25 1V6",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5 2.25H2V4.25H7.5V2.25Z",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.5 6.5C2.63807 6.5 2.75 6.38807 2.75 6.25C2.75 6.11193 2.63807 6 2.5 6C2.36193 6 2.25 6.11193 2.25 6.25C2.25 6.38807 2.36193 6.5 2.5 6.5Z",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.5 6.5C4.63807 6.5 4.75 6.38807 4.75 6.25C4.75 6.11193 4.63807 6 4.5 6C4.36193 6 4.25 6.11193 4.25 6.25C4.25 6.38807 4.36193 6.5 4.5 6.5Z",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.5 8.5C2.63807 8.5 2.75 8.38807 2.75 8.25C2.75 8.11193 2.63807 8 2.5 8C2.36193 8 2.25 8.11193 2.25 8.25C2.25 8.38807 2.36193 8.5 2.5 8.5Z",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.5 8.5C4.63807 8.5 4.75 8.38807 4.75 8.25C4.75 8.11193 4.63807 8 4.5 8C4.36193 8 4.25 8.11193 4.25 8.25C4.25 8.38807 4.36193 8.5 4.5 8.5Z",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.5 10.5C2.63807 10.5 2.75 10.3881 2.75 10.25C2.75 10.1119 2.63807 10 2.5 10C2.36193 10 2.25 10.1119 2.25 10.25C2.25 10.3881 2.36193 10.5 2.5 10.5Z",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.5 10.5C4.63807 10.5 4.75 10.3881 4.75 10.25C4.75 10.1119 4.63807 10 4.5 10C4.36193 10 4.25 10.1119 4.25 10.25C4.25 10.3881 4.36193 10.5 4.5 10.5Z",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecuritysystemAlarm);
export default __webpack_public_path__ + "static/media/security system-alarm.f8e1adfb.svg";
export { ForwardRef as ReactComponent };